import { createRouter, createWebHistory } from 'vue-router';
import { useUserStoreHook } from '@/stores/user';
import { useGlobalConfigStoreHook } from '@/stores/globalConfig';
import { ElLoading } from 'element-plus';
import { getUserInfoIfNeeded } from '@/services/user';
import { fetchGlobalConfig } from '@/services/globalConfig';
import { app } from '@/main';
import { routes } from './config';
import { isEmpty } from 'lodash';
import { syncRouteMetaLabels } from './syncRouteMetaLabels';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});
let syncedPermissions: PermissionItem[] | undefined;

router.beforeEach(async (to, from, next) => {
  // console.log(`路由守卫触发: from ${from.path} to ${to.path}`);
  const userStore = useUserStoreHook();
  ElLoading.service({ fullscreen: true });

  // 处理飞书回调时的 token 参数
  if (typeof to.query.token === 'string' && to.path === '/') {
    userStore.setToken(to.query.token);
    next({ path: to.path, query: { ...to.query, token: undefined } });
    return;
  }

  let user = '';
  if (typeof to.query.user === 'string' && to.path === '/') {
    user = to.query.user;
  }

  // 获取 token（首先从 Vuex 用户状态或本地存储中获取）
  let token = userStore.getToken;

  let userInfo = userStore.userInfo;

  // console.log("token", token, "userInfo", userInfo);

  // 如果 token 存在，且目标路径是登录页，跳转到主页
  if (token && to.path === '/login') {
    next({ path: from.path || '/' });
    return; // 返回，确保后续的代码不再执行
  }

  // 如果没有 token 且目标路径不是登录页，跳转到登录页
  if (!token && to.path !== '/login') {
    next({ path: '/login', query: { user: user } });
    return; // 返回，确保后续的代码不再执行
  }
  const globalConfig = useGlobalConfigStoreHook().config;
  if (token) {
    const needRefreshConfig = app.config.globalProperties.$needRefreshConfig || !userInfo || isEmpty(globalConfig);
    if (needRefreshConfig) {
      await getUserInfoIfNeeded();
      await fetchGlobalConfig();
    }
    app.config.globalProperties.$needRefreshConfig = false;
  }

  const permissions = userStore.userInfo?.permissions || [];
  if (permissions !== syncedPermissions) {
    syncRouteMetaLabels(router, permissions, to);
    syncedPermissions = permissions;
  }

  // 继续路由
  next();
});

router.afterEach(to => {
  // 在afterEach中设置页面标题
  let title = '财务系统';
  if (to.meta && (to.meta.title || to.meta.label)) {
    title = `${to.meta.title || to.meta.label} - ${title}`;
  }
  document.title = title;
  ElLoading.service().close();
});

let redirectPath = `${window.location.origin}`;
function goToLoginedPage() {
  window.location.href = redirectPath;
}

export default router;
export { goToLoginedPage, redirectPath };
